module.exports = __webpack_public_path__ + "images/f4e15333ffab4a20bc9350ab5c303412-profile_overlay.jpg";